import { APIAdapter } from '@/lib/http';

const clinicTablesApi = APIAdapter(process.env.CLINIC_TABLES_API_URL);

export default {
  getIcd10Codes: (searchTerms = '') =>
    clinicTablesApi
      .get('/icd10cm/v3/search', {
        params: {
          sf: 'code,name',
          df: 'code,name',
          maxList: 100,
          terms: searchTerms,
        },
      })
      .then((res) => res.data),
  getProviders: (searchTerms = '') =>
    clinicTablesApi
      .get('/npi_org/v3/search', {
        params: {
          df: 'NPI,name.full,provider_type,addr_practice.full,licenses,misc',
          maxList: 100,
          terms: searchTerms,
        },
      })
      .then((res) => res.data),
};
